export enum DayOptionId {
    AllDay = 'allDay',
    IsClosed = 'isClosed',
    Customized = 'customized'
}